import React from "react";
import styles from "./index.module.scss";

export const Loader = ({className = ''}) => {
  return <span className={`${styles.loader} ${className}`}></span>;
};
